/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForIntegratedToolsAlert extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForIntegratedToolsAlert");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForIntegratedToolsAlert.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForIntegratedToolsAlert>): BackgroundJobPayloadForIntegratedToolsAlert {
        let obj = Object.assign(new BackgroundJobPayloadForIntegratedToolsAlert(), model);
        BackgroundJobPayloadForIntegratedToolsAlert.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForIntegratedToolsAlert>): BackgroundJobPayloadForIntegratedToolsAlert {
        if (!model) return null;
        return BackgroundJobPayloadForIntegratedToolsAlert.newInstance(<BackgroundJobPayloadForIntegratedToolsAlert> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForIntegratedToolsAlert) {
        if (!obj) return;

        models.BackgroundJobPayloadForIntegratedToolsAlert.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForIntegratedToolsAlert): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForIntegratedToolsAlert.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Integrated Tool to select
     */
    integrated_tool: models.IntegratedToolName;

    alert_type: models.IntegratedToolAlertType;

    /**
     * alert data in json encoded text
     */
    alert_data: string;

}
